import { render, staticRenderFns } from "./imgarea.vue?vue&type=template&id=614181fb&"
import script from "./imgarea.vue?vue&type=script&lang=js&"
export * from "./imgarea.vue?vue&type=script&lang=js&"
import style0 from "./imgarea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports